import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';

//import moment from 'moment';
//import 'moment-duration-format';
import { isDefined, sortReactTable } from '../../../../utils';
import { pageLoaded } from '../../../../utils';
import { columnsAccessors } from '../../../../constants';
import { SurveyTypeDictionary } from '../../../../generated';
import SurveyNameAndTypeGetter from '../../../../components/v3/AdminScreenV3/SurveyNameAndTypeGetter';
import SurveyCreator from '../../../../components/v3/AdminScreenV3/SurveyCreator';
//import AddItemIcon from '../../../icons/AddItemIcon';
import LoadingControl from '../../../../components/LoadingControl';
import SurveyFormIcon from '../../../../icons/SurveyFormIcon';
import { ZRole } from '../../../../generated';

import {
    updateProps,
    loadSurveysScreen,
    saveSurvey,
} from './SurveysScreenActions';

const views = {
    showAllSurveys: 'showAllSurveys',
    createNewSurvey: 'createNewSurvey'
}

class SurveysScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            view: views.showAllSurveys,
            showCreateNewSurveyPopUp: false,
            newSurvey: undefined,
        };

        this.showCreateNewSurveyPopUp = this.showCreateNewSurveyPopUp.bind(this);
        this.closeCreateNewSurveyPopUp = this.closeCreateNewSurveyPopUp.bind(this);

        this.getSurveysResultTable = this.getSurveysResultTable.bind(this);
        this.backToSurveysScreen = this.backToSurveysScreen.bind(this);
        this.saveSurvey = this.saveSurvey.bind(this);
    }

    componentDidMount() {
        pageLoaded('SurveysScreen');
        this.props.dispatch(loadSurveysScreen());
    }

    showCreateNewSurveyPopUp() {
        this.setState({ showCreateNewSurveyPopUp: true });
    }

    closeCreateNewSurveyPopUp(surveyFormName, surveyFormType) {
        const newSurvey = {
            name: surveyFormName,
            type: surveyFormType
        };

        this.setState({
            showCreateNewSurveyPopUp: false,
            view: views.createNewSurvey,
            newSurvey: newSurvey,
        });

    }

    backToSurveysScreen() {
        this.setState({ view: views.showAllSurveys });
    }

    saveSurvey(surveyToSave) {
        this.setState({ view: views.showAllSurveys });
        if (isDefined(surveyToSave)) {
            this.props.dispatch(saveSurvey(surveyToSave));
        }
    }

    getSurveysResultTable() {
        const
            {
                surveyFormsSummary,
            } = this.props;

        let result = {};
        const nameColumn = {
            Header: 'Name',
            accessor: 'nameNode',
        };
        const statusColumn = {
            Header: 'Status',
            accessor: columnsAccessors.status
        };
        const typeColumn = {
            Header: 'Type',
            accessor: columnsAccessors.surveyType
        };
        const actionColumn = {
            Header: 'action',
            accessor: columnsAccessors.action
        };

        result.columns = [nameColumn, statusColumn, typeColumn, actionColumn];

        result.data = (surveyFormsSummary && Array.isArray(surveyFormsSummary)) ? surveyFormsSummary : [];

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)) {
                    row.nameNode = (<div className="flex-container-start">
                        <div>
                            <SurveyFormIcon />
                        </div>
                        <div style={{ margin: "0 0 10px 10px" }}>{row.name}</div>
                    </div>)
                }

                if (isDefined(row.typeId)) {
                    let avatarStyle = "survey-type-avatar ";
                    if (SurveyTypeDictionary[row.typeId] === "Agent") {
                        avatarStyle += " background-color-primary-300";
                    } else if (SurveyTypeDictionary[row.typeId] === "Customer") {
                        avatarStyle += " background-color-secandary-200";
                    } else if (SurveyTypeDictionary[row.typeId] === "QA") {
                        avatarStyle += " background-color-fourth-200";
                    }

                    row.surveyType =
                        (<div className={avatarStyle}>
                            {SurveyTypeDictionary[row.typeId]}
                        </div>)

                }
                if (isDefined(row.isEnabled)) {
                    var statusName = row.isEnabled ? 'LIVE' : 'DRAFT'

                    const avatarStyle = row.isEnabled ? "live-survey-avatar" : "draft-survey-avatar";
                    row.status = (<div className={avatarStyle}>
                        {statusName}
                    </div>);

                }
                row.action = 'Deactivate/Delete'
            })
        }

        const loading = !surveyFormsSummary;
        const surveysResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="admin-page-users-table -striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            //onClick(rowInfo.original.id)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return surveysResultTable;
    }

    render() {
        const
            {
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }
        if (currentUser.RoleId !== ZRole.Manager &&
            currentUser.RoleId !== ZRole.Admin &&
            currentUser.RoleId !== ZRole.SuperAdmin) {
            return <LoadingControl />;
        }

        if (this.state.view === views.showAllSurveys) {
            var surveysResultTable = this.getSurveysResultTable();
            const viewInteractionsButton = (
                <div className="v3-button agent-view-interactions" onClick={this.showCreateNewSurveyPopUp}>
                    New Survey
                </div>);

            return (
                <div className="main-page-width">
                    <div className="teams-table-for-manager filters-wrapper" style={{ marginTop: '28px' }}>
                        <div className="teams-table-for-manager filter-area-title-wrapper">
                            <label className="teams-table-for-manager all-teams-title">All Surveys</label>
                        </div>
                        <div className="teams-table-for-manager teams-filter-names-wrapper">
                            {viewInteractionsButton}
                        </div>
                    </div>
                    <div style={{ position: 'relative', zIndex: 0 }}>
                        {surveysResultTable}
                    </div>
                    {this.state.showCreateNewSurveyPopUp &&
                        (<SurveyNameAndTypeGetter
                            selectSurveyFormType={this.selectSurveyFormType}
                            onClose={this.closeCreateNewSurveyPopUp} />)}
                </div>);
        }
        else {
            return (
                <div className="main-page-width" style={{ margin: '0' }}>
                    <div className="flex-container" style={{ margin: '0' }}>
                        <SurveyCreator
                            backToSurveysScreen={this.backToSurveysScreen}
                            newSurvey={this.state.newSurvey}
                            saveSurvey={this.saveSurvey} />
                    </div>

                </div>);
        }
    }
}

const select = state => ({ ...state.SurveysScreen, ...state.session });

export default connect(select)(SurveysScreen);